/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */

import type { SVGProps } from 'react';

import type { IconComponentProps } from '../../icon/icon.types';
import { Icon } from '../icon';

const Info = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    className="Icon/Info"
    viewBox="0 0 24 24"
    {...props}
  >
    <g className="SVG">
      <path
        fill="#0E0E0E"
        d="M13.776 8.333c-.093.56-.453.88-1.253.88s-1.094-.346-1.094-.813c0-.093.014-.213.067-.533.093-.56.453-.88 1.253-.88s1.094.346 1.094.813c0 .093-.014.213-.067.533m.76 7.294c-.893 1.013-1.64 1.533-2.56 1.533-1.093 0-1.653-.627-1.653-1.6 0-.293.026-.52.133-1.067l.533-2.853H8.91l.254-1.52h4.053l-1.027 5.467.227.066 1.867-1.906 1.066.946z"
      />
      <path
        fill="#0E0E0E"
        fillRule="evenodd"
        d="M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10m-1.667 0a8.333 8.333 0 1 1-16.666 0 8.333 8.333 0 0 1 16.666 0"
        clipRule="evenodd"
      />
    </g>
  </svg>
);

export const InfoIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: IconComponentProps) => {
  return (
    <Icon
      data-testid={testId || 'info-icon'}
      icon={Info}
      {...props}
      size={size}
    />
  );
};
